module.exports = __webpack_public_path__ + "static/img/active8.379b0944.png";